// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"03c84f5511bbf817998c","454":"87f5539bee8ce0b8155e"}[chunkId] + ".js";
};